import type { ClientMeterType, ClientObjectType } from 'api/client'
import { RecipientTypeEnum } from 'Modules/Communication/shared/models/Inbox'
import {
  IRecipientModel,
  IRecipientQueryModel,
  RecipientOpenState,
} from 'Modules/Communication/shared/models/Recipients'
import { ISendEmailState, ISendSmsState } from '../shared/SendMessage'

export interface SystemState {
  sendMessage: {
    recipients: RecipientState
    // To handle logic regarding frequent users
    sms: ISendSmsState
    email: ISendEmailState
  }
}

export interface RecipientState {
  filters: IRecipientQueryModel
  listedRecipients: IRecipientModel[]
  listedRecipientsRemovalQueue: IRecipientModel[]
  openState: RecipientOpenState
  openStateType: RecipientTypeEnum | null
  meters: ClientMeterType[]
  objects: ClientObjectType[]
}

export const getMessageRecipients = (state: SystemState) =>
  state.sendMessage.recipients

export const getListedRecipient = (nameId: string) => (state: SystemState) => {
  const listedRecipients = getMessageRecipients(state).listedRecipients
  return listedRecipients.find((recipient) => recipient.nameId === nameId)
}

export const getListedRecipients = (state: SystemState) =>
  getMessageRecipients(state).listedRecipients

export const getRecipientOpenState = (state: SystemState) =>
  getMessageRecipients(state).openState

export const getRecipientObjects = (state: SystemState) =>
  getMessageRecipients(state).objects

export const getRecipientMeters = (state: SystemState) =>
  getMessageRecipients(state).meters

export const getListedRecipientsRemovalQueue = (state: SystemState) =>
  getMessageRecipients(state).listedRecipientsRemovalQueue
